<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="basic-paragraph1"><span class="body-copy"></span></p>
<p class="basic-paragraph2"><span class="body-copy1">Executive Book Editor: Elaine Brelsford</span></p>
<p class="basic-paragraph2"><span class="body-copy1">Copy Editor: Ann Hammel</span></p>
<p class="basic-paragraph2"><span class="body-copy1">Proofing: Hannah Alton</span></p>
<p class="basic-paragraph2"><span class="body-copy1">Graphic Design: Lynda Smith</span></p>
<p class="basic-paragraph2"><span class="body-copy1">Cover Design: Michael Buckingham</span></p>
<p class="basic-paragraph1"><span class="body-copy"></span></p>
<p class="basic-paragraph"><span class="authorname">About the Author</span><span class="authorname"></span></p>
<p class="basic-paragraph3"><span class="body-copy">Ann Hazelwood is a former shop owner and native of St. Charles Missouri. She's always adored quilting and is a certified quilt appraiser. She's the author of the wildly successful Colebridge Community series and considers writing one of her greatest passions. Titles include: Colebridge Community series - The Basement Quilt, The Potting Shed Quilt, The Funeral Parlor Quilt, The Jane Austen Quilt Club, The Ghostly Quilts on Main, Quilted Lilies, A Colebridge Quilted Christmas.  She has also published the Wine Country Quilt Series, East Perry County series and is now writing the Door County Quilt series.</span></p>
<p class="basic-paragraph1"><span class="body-copy"></span></p>
<div class="basic-text-frame">
<p class="bodytext"><span class="testimonial-body"></span></p>
<p class="bodytext1"><span class="testimonial-body"></span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// quilt-left-behind_split1.vue?8ffb5e4e